jQuery(document).ready(function($) {
  setTimeout(function(){
    $('.advanced-search-select2').select2();
  }, 1000);
});
